import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { createGrowlsSelector } from 'selectors'
import * as constants from 'view/styles/constants'
import { Growl, NotificationActions } from 'store/notification'
import { GrowlItem } from './GrowlItem'

export interface GrowlListProps {
  onDismiss: (id: string) => unknown
  growls: Growl[]
}

const mapStateToProps = createStructuredSelector({
  growls: createGrowlsSelector()
})

const mapDispatchToProps = {
  onDismiss: NotificationActions.dismissGrowl
}

const GrowlListRoot = styled.ol`
  position: absolute;
  margin: 6px auto;
  left: 0;
  right: 0;
  list-style-type: none;
  width: 320px;
  z-index: ${constants.zIndexGrowl};
  li {
    margin-bottom: 5px;
  }
`

export class GrowlListComponent extends React.PureComponent<GrowlListProps> {
  render() {
    const { growls, onDismiss } = this.props

    if (growls.length === 0) {
      return null
    } else {
      const growlItems = growls.map(growl => <GrowlItem key={growl.id} {...growl} onDismiss={onDismiss} />)
      return <GrowlListRoot>{growlItems}</GrowlListRoot>
    }
  }
}

export const GrowlList = connect(mapStateToProps, mapDispatchToProps)(GrowlListComponent)
